import axios from 'axios';

// TODO: #646 use named export. Replace library-specific names
export default axios.create({
  headers: { 'Content-Type': 'application/json' },
});

export const axiosFileService = axios.create({
  headers: { 'Content-Type': 'x-www-form-urlencoded' },
});



// WEBPACK FOOTER //
// ./services/axiosService.js